import { ItemType } from './MultiSelect';

export const getFormattedFilter = (filter: string[]): string =>
  filter.length === 1 && !filter[0] ? ',' : filter.join(',');

export const getSelectedItems = (filters: string[], items: ItemType[]) =>
  filters.map(
    (filter) => items.find(({ value }) => filter === value) as ItemType,
  );

export const withNotIndicatedFilter = (
  items: ItemType[],
  notIndicatedFilterLabel: string,
) =>
  items.reduce(
    (acc: ItemType[], selection: ItemType) =>
      !selection.value
        ? [{ ...selection, label: notIndicatedFilterLabel }, ...acc]
        : [...acc, selection],
    [],
  );
